import React, { useEffect, useState } from 'react'
import { addUserToRole, removeUserFromRole } from '../../apiServices/UserManagementApi';
import CustomDialog from '../CustomDialogue';
import { Autocomplete, Button, FormControlLabel, Checkbox } from '@mui/material';
import { AppUser } from '../../helpers/interfaces';
import { Add } from '@mui/icons-material';
import { FormEditMode, GlobalRole } from '../../helpers/constants';
import { useAppSelector } from '../../store/store';
import { CustomTextField } from '../../layouts/theme';
import { getUserEmail, getUserFullName, showConfirmBox } from '../../helpers/utils';

interface Props {
    formEditMode: number
    setAppUsers: React.Dispatch<React.SetStateAction<AppUser[]>>
    appUserToEdit: AppUser | null
    openUserForm: boolean
    setOpenUserForm: React.Dispatch<React.SetStateAction<boolean>>
}

function CreateEditUser(props: Props) {
    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
    const cmdbUsersId = useAppSelector(state => state.cmdbUsersId.value);


    useEffect(() => {
        if (props.formEditMode === FormEditMode.EDIT) {
            setSelectedUserId(props.appUserToEdit?.id ?? null)
            setIsAdmin(props.appUserToEdit?.roles.includes(GlobalRole.Admin) ?? false)
        }
    }, [props.formEditMode, props.appUserToEdit])


    function createNewUser() {
        if (selectedUserId === null) return
        addUserToRole({ user_principal_id: selectedUserId, role: GlobalRole.User }).then(user => {
            if (isAdmin) {
                addUserToRole({ user_principal_id: selectedUserId, role: GlobalRole.Admin }).then(user => {
                    props.setOpenUserForm(false);
                    props.setAppUsers(users => [...users, { id: selectedUserId, name: getUserFullName(selectedUserId), email: getUserEmail(selectedUserId), roles: [GlobalRole.User, GlobalRole.Admin] }])
                })
            }
            else {
                props.setOpenUserForm(false);
                props.setAppUsers(users => [...users, { id: selectedUserId, name: getUserFullName(selectedUserId), email: getUserEmail(selectedUserId), roles: [GlobalRole.User] }])
            }
        })
    }

    function updateUser() {
        if (selectedUserId === null) return
        if (props.appUserToEdit?.roles.includes(GlobalRole.Admin) && !isAdmin) {
            showConfirmBox("Are you sure you want to remove Admin role from this user?", "Remove Admin Role", "Yes", "No").then(result => {
                removeUserFromRole({ user_principal_id: selectedUserId, role: GlobalRole.Admin }).then(result => {
                    props.setOpenUserForm(false);
                    props.setAppUsers(users => users.map(u => u.id === props.appUserToEdit?.id ? { ...u, roles: [GlobalRole.User] } : u))
                })
            })
        }
        else if (!props.appUserToEdit?.roles.includes(GlobalRole.Admin) && isAdmin) {
            addUserToRole({ user_principal_id: selectedUserId, role: GlobalRole.Admin }).then(user => {
                props.setOpenUserForm(false);
                props.setAppUsers(users => users.map(u => u.id === props.appUserToEdit?.id ? { ...u, roles: [GlobalRole.User, GlobalRole.Admin] } : u))
            })
        }
        else {
            props.setOpenUserForm(false);
        }
    }

    return (
        cmdbUsersId &&
        <>
            <CustomDialog dialogTitle={props.formEditMode === FormEditMode.CREATE ? 'Add New User ' : 'Update User '} setOpenDialog={props.setOpenUserForm} openDialog={props.openUserForm}>
                <form>
                    <div >
                        <label className='title-label'>Select User Email <span className='important'>*</span></label>
                    </div>
                    <div className='col-12'>
                        <div className="form-group mb-0">
                            <div className="">
                                <Autocomplete disabled={props.formEditMode===FormEditMode.EDIT} id="newUserEmail" options={[null, ...cmdbUsersId]} getOptionLabel={(option) => getUserFullName(option, true) ?? 'User not Selected'} autoSelect multiple={false} size="small"
                                    value={selectedUserId} onChange={(e, value) => setSelectedUserId(value)}
                                    renderInput={(params) => (<CustomTextField {...params} margin="none" variant="outlined" size='small' />)}
                                />
                            </div>
                        </div>
                    </div>
                    <br />
                    <div >
                        <label className='title-label'>Role <span className='important'>*</span></label>
                    </div>
                    <div className='col-12'>
                        <div className="form-group mb-0">
                            <div className="">
                                <FormControlLabel control={<Checkbox color='secondary' checked={true} disabled />} label='User' />
                                <FormControlLabel control={<Checkbox color='secondary' checked={isAdmin} onChange={(e, checked) => setIsAdmin(checked)} />} label='Admin' />
                            </div>
                        </div>
                    </div>
                    <br />

                    <div className="form-group mt-3 mb-5" style={{ float: 'right' }}>
                        <Button disabled={!selectedUserId} variant="contained" color='secondary' onClick={props.formEditMode === FormEditMode.CREATE ? createNewUser : updateUser} >
                            <Add />&nbsp; {props.formEditMode === FormEditMode.CREATE ? 'Add User' : 'Update User'}
                        </Button>
                    </div>
                </form >


            </CustomDialog>

        </>
    )
}

export default CreateEditUser